const consequence = {
  bindings: {
    index: '<',
    newConsequence: '<',
    viewMode: '<',
    onRemove: '&',
    onSave: '&',
    onEdit: '&',
  },
  templateUrl: '/modules/psa/script-form/consequence/consequence.html',
  controller: 'ConsequenceController',
};

angular
  .module('psa.module')
  .component('consequence', consequence);
